import axiosClient from './axiosClient';
import { urlApiStatistic } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';
import { ITotalStatistic } from '~/utils/interface/statistics';

const statisticApi = {
  getTotalStatistic() {
    const url = `${urlApiStatistic.getTotalStatistic}`;
    return axiosClient.get<IBaseResponse<ITotalStatistic>>(url);
  },
};

export default statisticApi;
